module.exports = __webpack_public_path__ + "static/media/logoTop.43aea44b.png";